import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getFirebaseBackend } from '../../authUtils';
import { Observable, of, throwError } from "rxjs";
import { Login } from "../types/requests";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ApiRoutes } from "../routes/api.routes";
import { TokenService } from "./token.service";
import { catchError, map, tap } from "rxjs/operators";
import { HttpResponse } from "../types/http-response.type";
import { AuthenticatedUserService } from "./authenticated-user.service";
import { IUser, User } from "../models/User";
import Swal from 'sweetalert2';


@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    redirectPath: string = '';
    user!: User;
    authenticated: boolean = false;

    constructor(
        private http: HttpClient,
        private tokenService: TokenService,
        private authenticatedUserService: AuthenticatedUserService,
        private router: Router
    ) {}

    /**
     * Returns the current user
     */
    public currentUser(): User {
        return getFirebaseBackend().getAuthenticatedUser();
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string, loginType: string) {
        
        const body = { email: email, password: password, loginType: loginType }

        return this.http.post<any>(ApiRoutes.auth.login, body).pipe(
            map(response => {
                if (response && response.accessToken) {
                    this.tokenService.set(response.accessToken);
                    return response;
                }
                throw response;
            }),
            catchError((err) => {
                if (err && err.error && err.error.code === 'WRONG_PORTAL_EMPLOYEE') {
                    Swal.fire({
                        title: 'Portal Incorrecto',
                        text: err.error.message,
                        icon: 'warning',
                        confirmButtonText: 'Ir a Portal de Empleados',
                        showCancelButton: true,
                        cancelButtonText: 'Cancelar',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.router.navigate(['/account/login']);
                        }
                    });
                    return of(false);
                } else if (err && err.error && err.error.code === 'WRONG_PORTAL_CUSTOMER') {
                    Swal.fire({
                        title: 'Portal Incorrecto',
                        text: err.error.message,
                        icon: 'warning',
                        confirmButtonText: 'Ir a Portal de Clientes',
                        showCancelButton: true,
                        cancelButtonText: 'Cancelar',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.router.navigate(['/account/login-client']);
                        }
                    });
                    return of(false);
                }

                let errorMsg = 'Usuario o contraseña incorrectos.';
                if (err && err.error && err.error.message && err.error.message !== 'Unauthorized') {
                    errorMsg = err.error.message;
                } else if (err && err.message && err.status !== 401) {
                    errorMsg = err.message;
                }
                
                Swal.fire({
                    title: 'Acceso denegado',
                    text: errorMsg,
                    icon: 'error',
                    confirmButtonColor: '#d33'
                });
                return of(false);
            })
        );
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return this.http.post(ApiRoutes.auth.password_reset, {
            'email': email
        }).pipe(map(response => {
            return true
        }),
        catchError((err) => 
            of(
                Swal.fire({
                    title: 'Error',
                    text: err + ' Revisa tus credenciales',
                    icon: 'error'
                  })
            )
        ));
    }

    changePassword(token: string, password: string) {
        return this.http.post(ApiRoutes.auth.change_password, {
            'token': token,
            'password' : password
        }).pipe(map(response => {
            return true
        }),
        catchError((err) => 
            of(
                Swal.fire({
                    title: 'Error',
                    text: err,
                    icon: 'error'
                })
            )
        ));
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        return getFirebaseBackend().registerUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Logout the user
     */
    logout() {
        this.tokenService.remove();
        return this.http.delete(ApiRoutes.auth.logout);
    }

    // authenticatedUser() {
    //     console.log("auth service")
    //     return  this.http.get(ApiRoutes.auth.authenticatedUser).pipe(
    //         map(response => {
    //             console.log("auth exitoso", response['email'])
    //             if (response['email']) {
    //                 console.log("must be true")
    //                 return response
    //             }else{
    //                 console.log("must be false")
    //                 return response
    //             }
    //         }),
    //         catchError((err) => 
    //             of(
    //                 console.log("must have error", err),
    //                 alert(err), 
    //             )
    //         )
    //     );
    // }

    authenticatedUser(): Observable<HttpResponse<IUser>> {
        
        return this.http.get<HttpResponse<IUser>>(ApiRoutes.auth.authenticatedUser).pipe(
            map((response) => {
                if (response) {
                   // this.authenticatedUserService.changeUserStatus(response.body)
                }

                return response
            }),
            catchError((err) => {
                return throwError(() => err);
            })
        );
    }
}

